import "uikit/dist/js/uikit.min.js";
import Swiper from "swiper";
import { Autoplay, Navigation, EffectFade, Keyboard } from "swiper/modules";

(function () {
	var popup = document.getElementById("promo-popup");
	var dismissBtn = document.getElementById("promo-popup-dismiss");
	var overlay = document.getElementById("promo-popup-overlay");
	var promoLink = popup ? popup.querySelector(".promo-popup__link") : null;
	var storageKey = "albrightPromoDismissed";
	var cookieMaxAge = 60 * 60 * 24;

	if (!popup || !dismissBtn) {
		return;
	}

	function clearDismissedPopup() {
		try {
			if (window.localStorage) {
				window.localStorage.removeItem(storageKey);
			}
		} catch (e) {
			// localStorage may be blocked in some browsers.
		}

		document.cookie =
			storageKey +
			"=; path=/; max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax";
	}

	function getDismissedUntil() {
		var storedUntil = 0;
		var cookieUntil = 0;
		var cookieMatch = document.cookie.match(
			new RegExp("(^|; )" + storageKey + "=([^;]+)"),
		);

		try {
			if (window.localStorage) {
				storedUntil = parseInt(
					window.localStorage.getItem(storageKey) || "0",
					10,
				);
			}
		} catch (e) {
			// localStorage may be blocked in some browsers.
		}

		if (cookieMatch && cookieMatch[2]) {
			cookieUntil = parseInt(decodeURIComponent(cookieMatch[2]), 10);
		}

		if (isNaN(storedUntil)) {
			storedUntil = 0;
		}

		if (isNaN(cookieUntil)) {
			cookieUntil = 0;
		}

		if (storedUntil <= Date.now() && cookieUntil <= Date.now()) {
			clearDismissedPopup();
			return 0;
		}

		return Math.max(storedUntil, cookieUntil);
	}

	function hasDismissedPopup() {
		return getDismissedUntil() > Date.now();
	}

	function setDismissedPopup() {
		var expiresAt = Date.now() + cookieMaxAge * 1000;

		try {
			if (window.localStorage) {
				window.localStorage.setItem(storageKey, String(expiresAt));
			}
		} catch (e) {
			// localStorage may be blocked in some browsers.
		}

		document.cookie =
			storageKey +
			"=" +
			expiresAt +
			"; path=/; max-age=" +
			cookieMaxAge +
			"; expires=" +
			new Date(expiresAt).toUTCString() +
			"; SameSite=Lax";
	}

	function showPopup() {
		popup.classList.add("is-visible");
		popup.setAttribute("aria-hidden", "false");
	}

	function hidePopup() {
		popup.classList.remove("is-visible");
		popup.setAttribute("aria-hidden", "true");
		setDismissedPopup();
	}

	if (hasDismissedPopup()) {
		return;
	}

	function startPopupTimer() {
		window.setTimeout(showPopup, 2000);
	}

	if (document.readyState === "complete") {
		startPopupTimer();
	} else {
		window.addEventListener("load", startPopupTimer, { once: true });
	}

	dismissBtn.addEventListener("click", hidePopup);

	if (promoLink) {
		promoLink.addEventListener("click", function () {
			setDismissedPopup();
		});
	}

	if (overlay) {
		overlay.addEventListener("click", hidePopup);
	}

	document.addEventListener("keydown", function (event) {
		if (event.key === "Escape" && popup.classList.contains("is-visible")) {
			hidePopup();
		}
	});
})();

// Initialize each image carousel independently so controls stay scoped per block instance.
document.querySelectorAll(".js-image-carousel").forEach((carousel) => {
	new Swiper(carousel, {
		modules: [Autoplay, Navigation, EffectFade, Keyboard],
		slidesPerView: 1,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		centeredSlides: true,
		loop: true,
		navigation: {
			nextEl: carousel.querySelector(".carousel-button-next"),
			prevEl: carousel.querySelector(".carousel-button-prev"),
		},
		pagination: {
			el: carousel.querySelector(".swiper-pagination"),
			type: "bullets",
			clickable: true,
		},
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
	});
});

// jQuery-specifc code
jQuery(function ($) {
	// Menu Dropdowns
	var svgOpen =
		'<button type="button" class="dropdown-trigger d-xl-none text-center lh-1" aria-label="Toggle submenu" aria-expanded="false"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24"><path fill="none" stroke="#000000" stroke-width="12" stroke-linecap="round" stroke-linejoin="round" d="M128 192l128 128 128-128"/></svg></button>';
	$("#main-nav .menu-item.dropdown").each(function () {
		var navLink = $(this).children("a.nav-link").first();

		// Appends the dropdown arrow next to the parent link.
		if (!$(this).children(".dropdown-trigger").length) {
			if (navLink.length) {
				navLink.after(svgOpen);
			} else {
				$(this).prepend(svgOpen);
			}
		}
	});
	$("#main-nav .menu-item .dropdown-trigger").click(function (e) {
		var dropdownMenu;

		e.preventDefault();
		dropdownMenu = $(this).siblings(".dropdown-menu");

		// Toggles the dropdown
		dropdownMenu.toggleClass("show");
		$(this).attr(
			"aria-expanded",
			dropdownMenu.hasClass("show") ? "true" : "false",
		);
	});
	// If #main-nav a.menu-item link is "#", open the dropdown instead of going to "#"
	$("#main-nav .menu-item a.nav-link").click(function (e) {
		var dropdownMenu;

		if ($(this).attr("href") === "#") {
			e.preventDefault();
			dropdownMenu = $(this).siblings(".dropdown-menu");
			dropdownMenu.toggleClass("show");
			$(this)
				.siblings(".dropdown-trigger")
				.attr(
					"aria-expanded",
					dropdownMenu.hasClass("show") ? "true" : "false",
				);
		}
	});

	// In the gravity form of ID 2, pre-populate the choices for the field ID 5 with all the 'floorplan' posts, set the label and value to the post title.
	// Get all the 'floorplan' posts
	$.ajax({
		url: "/wp-json/wp/v2/floorplan?per_page=100", // Adjust the per_page parameter as needed
		method: "GET",
		success: function (data) {
			var choices = [];
			data.forEach(function (post) {
				choices.push({
					label: post.title.rendered,
					value: post.title.rendered,
				});
			});
			// Now we have the choices, we can populate the field with ID 5 in the form with ID 2
			// Assuming you are using Gravity Forms, you can use the following code to populate the field
			var fieldId = 5; // The ID of the field you want to populate
			var formId = 2; // The ID of the form
			var selectField = $(
				"#gform_" + formId + " select#gfield_" + formId + "_" + fieldId,
			);
			if (selectField.length) {
				choices.forEach(function (choice) {
					selectField.append(
						$("<option>", {
							value: choice.value,
							text: choice.label,
						}),
					);
				});
			}
		},
		error: function (error) {
			console.error("Error fetching floorplan posts:", error);
		},
	});

	// Scrollspy classes
	$(".slide-in-bottom-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-bottom-medium; delay: 100",
	);
	$(".slide-in-left-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-left-medium; delay: 100",
	);
	$(".slide-in-right-md").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-right-medium; delay: 100",
	);
	$(".slide-in-bottom-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-bottom-small; delay: 100",
	);
	$(".slide-in-left-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-left-small; delay: 100",
	);
	$(".slide-in-right-sm").attr(
		"uk-scrollspy",
		"cls: uk-animation-slide-right-small; delay: 100",
	);
	$(".fade-in").attr("uk-scrollspy", "cls: uk-animation-fade; delay: 100");
	$(".fade-in-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-fade; delay: 100",
	);
	$(".slide-in-bottom-sm-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-bottom-small; delay: 100",
	);
	$(".slide-in-bottom-md-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-bottom-medium; delay: 100",
	);
	$(".slide-in-left-sm-children").attr(
		"uk-scrollspy",
		"target: > *; cls: uk-animation-slide-left-small; delay: 100",
	);
});
